/** Per-user memory of the collapsed inputs column of the Immobilienrechner (desktop only). */
export const INPUTS_COLLAPSED_STORAGE_KEY = 'damokles.calculator.inputsCollapsed';

export function readInputsCollapsed(): boolean {
  try {
    return window.localStorage.getItem(INPUTS_COLLAPSED_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function storeInputsCollapsed(collapsed: boolean): void {
  try {
    if (collapsed) window.localStorage.setItem(INPUTS_COLLAPSED_STORAGE_KEY, '1');
    else window.localStorage.removeItem(INPUTS_COLLAPSED_STORAGE_KEY);
  } catch {
    // Storage is optional: the column keeps its state for this visit only.
  }
}
